addAction = (tag, callback) => {
    window.bssB2BHooks = window.bssB2BHooks || {
        actions: {},
        filters: {},
    };
    window.bssB2BHooks.actions[tag] = callback;
};
addFilter = (tag, callback) => {
    window.bssB2BHooks = window.bssB2BHooks || {
        actions: {},
        filters: {},
    };
    window.bssB2BHooks.filters[tag] = callback;
};

const customSelector = (config, {page}) => {
  try {
    const themeSelector = {
        Dawn: {
            miniCart: {
                selectorMiniCart: 'upCart',
                selectorCard: "li.upcart-internal-cart-item",
                selectorFinalLinePrice: ".upcart-public-component-product-tile__price .transcy-money",
                selectorSubtotalPrice: ".styles_Footer__cartSubtotalValue__ .transcy-money, .styles_Footer__checkoutButton__ .transcy-money",
            }
      },
    }
    const themeName = window.Shopify?.theme?.schema_name;
    const newConfig = themeName ? themeSelector[themeName]?.[page] : null;
    if (!newConfig) return config;
    const el = document.getElementById(newConfig.selectorMiniCart)
    const shadow = el?.shadowRoot;
    const cartItems = shadow?.querySelectorAll(newConfig.selectorCard);
    if (cartItems) return null;
  } catch (error) {
    console.log("error",error)
  }
  return config
}

addFilter("custom:config_theme/installation", customSelector);

const configTheme = async () => {
  try {
    const themeSelectorMap1 = {
        Dawn: {
            miniCart: {
                selectorMiniCart: 'upCart',
                selectorCard: "li.upcart-internal-cart-item",
                selectorFinalLinePrice: ".upcart-public-component-product-tile__price .transcy-money",
                selectorSubtotalPrice: ".styles_Footer__cartSubtotalValue__ .transcy-money, .styles_Footer__checkoutButton__ .transcy-money",
            }
      },
    }
    const themeName = window.Shopify?.theme?.schema_name;
    const config = themeName ? themeSelectorMap1[themeName]?.['miniCart'] : null;

    if (!config) return;

    const { AjaxCartApi } = BSS_B2B.utils;
    let lineItems = [];

    try {
        const res =await AjaxCartApi.getCart();
        lineItems = res.items;
        if (!lineItems?.length) return;
    } catch (err) {
     BSS_B2B.logger?.error?.('[BSS B2B] Failed to fetch cart.js:', err);
    }

    const el = document.getElementById(config.selectorMiniCart)
    const shadow = el?.shadowRoot;

    const cartItems = shadow.querySelectorAll(config.selectorCard);
    cartItems.forEach(item => {
    const href = item.querySelector('a')?.getAttribute('href');
    if (!href) return;

    const originEls = [...item.querySelectorAll(config.selectorOriginPrice)];
    const finalEls = [...item.querySelectorAll(config.selectorFinalLinePrice)];
    const productMatch = lineItems.find(p => {
        const sp = p.selling_plan_allocation?.selling_plan;
        return href.includes(String(p.variant_id)) &&
        (!sp || href.includes(String(sp?.id)));
    });

    const itemKey = productMatch?.key;

    if (itemKey) {
        item.setAttribute('bss-b2b-cart-item-key', itemKey);
    }

    originEls.forEach(el => {
        if (!el.hasAttribute('bss-b2b-item-original-price')) {
        el.setAttribute('bss-b2b-item-original-price', '');
        }

        if (!item.querySelector('.bss-b2b-qb-table')) {
        const div = document.createElement('div');
        div.className = 'bss-b2b-qb-table';
        el.parentNode?.insertBefore(div, el.nextSibling);
        }
    });

    finalEls.forEach(el => {
        if (!el.hasAttribute('bss-b2b-final-line-price')) {
        el.setAttribute('bss-b2b-final-line-price', '');
        }
    });
    });

    shadow.querySelectorAll(config.selectorSubtotalPrice).forEach(el => {
    if (!el.hasAttribute('bss-b2b-cart-total-price')) {
        el.setAttribute('bss-b2b-cart-total-price', '');
    }
    });
  } catch (error) {
    console.log("error",error)
  }
}

addAction("custom:cart/delayCart", configTheme);

const detectLinePriceEle = (linePriceEle, {key, attrCartItemKey, attrFinalLinePrice}) => {
    try {
        const attrFinalLinePrice = 'bss-b2b-final-line-price';
        const attrOriginLinePrice = 'bss-b2b-original-line-price';
        const elementLinePrice = document
            .querySelector("#upCart")
            .shadowRoot
            .querySelectorAll(
                [
                    `[${attrCartItemKey}${key ? `="${key}"` : ''}][${attrFinalLinePrice}]`,
                    `[${attrCartItemKey}${key ? `="${key}"` : ''}][${attrOriginLinePrice}]`,
                    `[${attrCartItemKey}${key ? `="${key}"` : ''}] [${attrFinalLinePrice}]`,
                    `[${attrCartItemKey}${key ? `="${key}"` : ''}] [${attrOriginLinePrice}]`,
                ].join(',')
            );
        if (elementLinePrice?.length) return [...elementLinePrice, ...linePriceEle];
    } catch (e) {
        console.log(e)
    }
    return linePriceEle;
}
addFilter('custom:cart/line_price_ele', detectLinePriceEle);

const detectSubTotalEle = (subtotalEle) => {
	try {
        const elementTotalPrice = document
            .querySelector("#upCart")
            .shadowRoot
            .querySelectorAll(
                [
                    '.styles_Footer__cartSubtotalValue__ .transcy-money',
                    '.styles_Footer__checkoutButton__ .transcy-money',
                    '[bss-b2b-cart-total-price]'
                ].join(',')
            );
        if (elementTotalPrice?.length) return [...elementTotalPrice, ...subtotalEle];
    } catch (e) {
        console.log(e)
    }
    return subtotalEle;
}
addFilter('custom:cart/sub_total_ele', detectSubTotalEle);

const detectCheckoutEle = (checkoutElements) => {
    try {
        const elementBtnCheckout = document
            .querySelector("#upCart")
            .shadowRoot
            .querySelectorAll(
                [
                    '.upcart-checkout-button',
                ].join(',')
            );
        if (elementBtnCheckout?.length) return [...elementBtnCheckout, ...checkoutElements];
    } catch (e) {
        console.log(e)
    }
    return subtotalEle;
}
addFilter('custom:cart/checkout_ele', detectCheckoutEle);

document.addEventListener("click", e => {
  const path = e.composedPath();
  const selectorCheckout = `.upcart-checkout-button`;
  const target = path.find(el => {
    return el?.matches?.(selectorCheckout);
  });
  if ((e.target && e.target.closest(selectorCheckout)) || target) {
      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();
      BSS_B2B.observer.cartSubject.notifyObserver('CartCheckout', 'ClickCheckout');
  }
}, 1); 

document.addEventListener(`bss_b2b:CustomCartUpdate`, function (e) {
    BSS_B2B.storage.cartStorage.clear()
});